import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Checkbox from '../../../../../../common/widgets/Checkbox';
import Icons from '../../../../../../common/widgets/Icons';
import { ProductOnOfferFilter } from '../../../../models/ProductOnOfferFilter';
import { resources } from '../../../../resources/resources';

interface ProductsOnOfferProps {
  productOnOffer: ProductOnOfferFilter;
  isPrevSelected: boolean;
  handleProductsOnOfferFilterChanged: (isSelected: boolean) => void;
}

export default function ProductsOnOfferFilter(
  props: Readonly<ProductsOnOfferProps>,
) {
  const { t: translate } = useTranslation();
  const { productOnOffer, isPrevSelected, handleProductsOnOfferFilterChanged } =
    props;

  const [showProductsOnOffer, setShowProductsOnOffer] =
    useState<boolean>(isPrevSelected);
  const [isExpanded, setIsExpanded] = useState<boolean>(true);

  const handleOnClick = () => {
    setShowProductsOnOffer(!showProductsOnOffer);
    handleProductsOnOfferFilterChanged(!showProductsOnOffer);
  };

  useEffect(
    () => setShowProductsOnOffer(() => isPrevSelected),
    [isPrevSelected],
  );

  return (
    <div
      className={`action-panel expandable expand-on-arrow ${
        isExpanded ? '' : 'collapsed'
      }`}
    >
      <div className="action-panel-title">
        <span>{translate(resources.filters.productsOnOfferTitle)}</span>
        <span
          className="action-panel-expand"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <Icons.ArrowUp />
        </span>
      </div>
      {isExpanded && (
        <div className="action-panel-content">
          <Checkbox
            isChecked={showProductsOnOffer}
            label={translate(resources.filters.productsOnOfferItem, {
              0: `${productOnOffer.count}`,
            })}
            onChange={handleOnClick}
            onLabelClick={handleOnClick}
          />
        </div>
      )}
    </div>
  );
}
